import React from 'react';
import DataResource from '../../../../common/v4/DataResource'
import Panel from '../../../../common/layout/Panel'

const AccessGroups = (props) => {
    const data = {
        url: `/admin/access/groups`,
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: `/admin/access/groups/{id}`,
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'Group Name'
            },
            {
                label: 'Description',
                source: 'description',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'Group Description'
            },
            {
                label: 'Users Count',
                source: 'users_count',
                type: 'number',
                editable: false,
                visible: true
            },
            {
                label: 'Rights Count',
                source: 'rights_count',
                type: 'number',
                editable: false,
                visible: true
            },
            {
                label: 'Created',
                source: 'created_at',
                type: 'datetime',
                editable: false,
                visible: true
            },
            {
                label: 'Updated',
                source: 'updated_at',
                type: 'datetime',
                editable: false,
                visible: true
            },
            {
                label: 'Delete',
                type: 'delete'
            }
        ]
    }

    return (   
        <Panel title="Access Groups">
            <DataResource
                addButtonText="Create Access Group" 
                addButtonLink="/admin/access/groups/create"
                data={data}
                {...props} 
            />
        </Panel>
    )
}

export default AccessGroups; 